// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__3YHj8","header":"MessagesList_header__-Abrz","chat":"MessagesList_chat__26lLF"};